import $ from "jquery";
import { Select2 } from "select2";
import { IonRangeSliderEvent } from "ion-rangeslider";
import "jquery-match-height";

import { debounce } from "./utils";

const filter = () => {
    let sortQuery = "";
    let filterQuery = "";
    const sort = $("form.sort .sort__select");

    if ($(".js-sort__select").length) {
        $(".js-sort__select").select2({
            width: "170",
            minimumResultsForSearch: Infinity,
        });
    }

    //фильтр с диапазоном
    if ($(".js-range-slider").length) {
        $(".js-range-slider").each(function () {
            let inputFrom = $(this)
                .siblings(".filter__range-row")
                .find(".filter__range-input_from");
            let inputTo = $(this)
                .siblings(".filter__range-row")
                .find(".filter__range-input_to");
            // let rangeChangeCount = 0;

            $(this).ionRangeSlider({
                hide_from_to: true,
                hide_min_max: false,
                type: "double",
                skin: "round",

                onStart: function (data) {
                    inputFrom.val(data.from);
                    inputTo.val(data.to);
                },

                onChange: function (data) {
                    inputFrom.val(data.from);
                    inputTo.val(data.to);
                },

                onFinish: function (data) {
                    const form = $(".js-filter").serialize();
                    updateFilterQuery(form);
                    if (sort.length) {
                        updateSortQuery(sort.val());
                    }
                    submitForm(updateUrl);
                    addQueryInLinks();
                },
            });
        });
    }

    $('.js-filter .filter__checkbox input[type="checkbox"]').on(
        "change",
        debounce(function () {
            const form = $(".js-filter").serialize();
            updateFilterQuery(form);
            if (sort.length) {
                updateSortQuery(sort.val());
            }
            submitForm(updateUrl);

            addQueryInLinks();
        }, 2000),
    );

    // Сортировка
    if (sort.length) {
        sort.on("change", function (e) {
            let value = $(this).val();

            const form = $(".js-filter").serialize();
            updateFilterQuery(form);
            updateSortQuery(value);
            submitForm(updateUrl);

            addQueryInLinks();
        });
    }

    function buildQueryParams() {
        const params = new URLSearchParams(filterQuery);

        if (sortQuery) {
            const sortPart = sortQuery.replace(/&$/, "");
            const eqIndex = sortPart.indexOf("=");
            if (eqIndex !== -1) {
                params.set(
                    sortPart.slice(0, eqIndex),
                    sortPart.slice(eqIndex + 1),
                );
            }
        }

        const searchInput = $(".js-search-query");
        if (searchInput.length) {
            params.set("search", searchInput.val());
        } else {
            const currentParams = new URLSearchParams(window.location.search);
            if (currentParams.has("search")) {
                params.set("search", currentParams.get("search"));
            }
        }

        params.delete("page");

        return params;
    }

    function submitForm(queryFunc) {
        if (history.pushState) {
            const baseUrl = new URL(window.location.href);
            const params = buildQueryParams();
            const newUrl = `${baseUrl.origin}${
                baseUrl.pathname
            }?${params.toString()}`;

            if ($(".search.catalog-list").length) {
                window.location.assign(newUrl);
                return;
            }

            history.pushState(null, null, newUrl);

            // добавляем параметры к брендам перед ajax-запросом
            let queryString = params.toString();
            queryString = queryString ? "?" + queryString : "";
            $(".brands__item a").each(function () {
                let href = $(this).attr("href").split("?")[0];
                let newHref = href + queryString;
                $(this).attr("href", newHref);
            });

            $(".ajax-wrapper").addClass("loading");
            $.ajax({
                url: newUrl,
                // data: queryFunc(),
                dataType: "html",
                type: "get",
                success: function (response, textStatus, jqXHR) {
                    if ($(response).find(".catalog__item").length) {
                        $(".msg.error").remove();
                        const items = $(response).find(".ajax-wrapper").html();
                        const pagination = $(response)
                            .find(".catalog-list__content .pagination")
                            .html();

                        $(".ajax-wrapper").removeClass("error").html(items);
                        //одинаковая высота карточек товаров
                        $(".catalog__item .name").matchHeight();
                        $(".catalog__item .prices").matchHeight();

                        $(".catalog-list .pagination").html(pagination);

                        $("html, body").animate(
                            {
                                scrollTop: $(".ajax-wrapper").offset().top,
                            },
                            300,
                        );

                        setTimeout(
                            $(".ajax-wrapper").removeClass("loading"),
                            500,
                        );
                        // location.reload(); // Автоматическое обновление страницы
                    } else {
                        $(".ajax-wrapper").removeClass("error").html("");
                        $(".catalog-list .pagination").html("");

                        $("html, body").animate(
                            {
                                scrollTop: $(".ajax-wrapper").offset().top,
                            },
                            300,
                        );

                        setTimeout(
                            $(".ajax-wrapper").removeClass("loading"),
                            500,
                        );
                        $(".ajax-wrapper")
                            .addClass("error")
                            .html(
                                '<div class="msg error">К сожалению, по Вашим параметрам ничего не нашлось :(</div>',
                            );
                        // location.reload(); // Автоматическое обновление страницы
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $(".ajax-wrapper").removeClass("error").html("");
                    $(".catalog-list .pagination").html("");

                    $("html, body").animate(
                        {
                            scrollTop: $(".ajax-wrapper").offset().top,
                        },
                        300,
                    );

                    setTimeout($(".ajax-wrapper").removeClass("loading"), 500);
                    $(".ajax-wrapper")
                        .addClass("error")
                        .html(
                            '<div class="msg error">К сожалению, по Вашим параметрам ничего не нашлось :(</div>',
                        );
                    console.log("ОШИБКИ AJAX запроса: " + textStatus);
                },
            });
        } else {
            console.warn("History API не поддерживается");
        }
    }

    function updateSortQuery(query = "default") {
        if (query == "default") {
            sortQuery = "";
        } else {
            sortQuery = `order=${query}&`;
        }
    }

    function updateFilterQuery(query) {
        filterQuery = query;
    }

    function updateUrl() {
        return buildQueryParams().toString();
    }

    // Query без page — пагинация не должна попадать в ссылки сайдбара
    function getSearchWithoutPage() {
        const params = new URLSearchParams(window.location.search);
        params.delete("page");
        const qs = params.toString();
        return qs ? `?${qs}` : "";
    }

    function addQueryInLinks(firstLoad = false) {
        const searchWithoutPage = getSearchWithoutPage();

        if (firstLoad) {
            $(".category__item").each(function () {
                const currentCat = $(this).find("a.current").first();
                let currentCatFlag = currentCat.length;

                if (currentCatFlag) {
                    currentCat
                        .closest(".category__item")
                        .find("a")
                        .each(function () {
                            let href = $(this).attr("href").split("?")[0];
                            let newHref = href + searchWithoutPage;
                            $(this).attr("href", newHref);
                        });
                }
            });
        } else {
            $(".category__item").each(function () {
                const currentCat = $(this).find("a.current").first();
                let currentCatFlag = currentCat.length;
                if (currentCatFlag) {
                    currentCat
                        .closest(".category__item")
                        .find("a")
                        .each(function () {
                            let href = $(this).attr("href").split("?")[0];
                            let newHref = href + searchWithoutPage;
                            $(this).attr("href", newHref);
                        });
                } else {
                    $(this)
                        .find("a")
                        .each(function () {
                            let href = $(this).attr("href").split("?")[0];
                            let newHref = href + "?" + sortQuery;
                            $(this).attr("href", newHref);
                        });
                }
            });
        }

        if (searchWithoutPage) {
            $(".filter__reset").fadeIn().css("display", "block");
        }
    }

    // Подставляем квери в ссылки при загрузке страницы
    addQueryInLinks(true);
};

export default filter;
